"use strict";

var _objectWithoutProperties = require("/root/website/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dialog = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _useOutsideClick = require("../../hooks/useOutsideClick");

var _dialog = require("./dialog.style");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? {
  children: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),
  onClose: _propTypes.func.isRequired
} : {};
var defaultProps = {
  children: null
};

var Dialog = function Dialog(_ref) {
  var children = _ref.children,
      onClose = _ref.onClose,
      props = _objectWithoutProperties(_ref, ["children", "onClose"]);

  var ref = (0, _react.useRef)(null);
  (0, _useOutsideClick.useOutsideClick)(ref, onClose);
  return (0, _core.jsx)(_dialog.Animation, {
    key: "modal",
    initial: {
      translateX: '100%'
    },
    animate: {
      translateX: '0%'
    },
    exit: {
      translateX: '100%'
    },
    transition: {
      duration: 0.3
    }
  }, (0, _core.jsx)(_dialog.Container, (0, _extends2.default)({
    ref: ref
  }, props), _react.default.Children.map(children, function (child) {
    return /*#__PURE__*/(0, _react.cloneElement)(child, {
      onClose: onClose
    });
  })));
};

exports.Dialog = Dialog;
process.env.NODE_ENV !== "production" ? Dialog.propTypes = propTypes : void 0;
Dialog.defaultProps = defaultProps;
Dialog.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Dialog",
  "props": {
    "children": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "string"
        }]
      },
      "required": false,
      "description": ""
    },
    "onClose": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    }
  }
};